import i18n from '@/i18n'

export default class LogoutUserError extends Error {
  readonly message = i18n.t('errors.logoutFaild') as string
}
